import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descargás el Manual',
    desc: 'Recibís el acceso inmediato a tu correo apenas completás el pago.'
  }, {
    num: '2',
    title: 'Hacés el Reset',
    desc: 'Seguís las instrucciones simples de comida y descanso por 14 días.'
  }, {
    num: '3',
    title: 'Recuperás tu Talle',
    desc: 'Mirás cómo el botón del pantalón vuelve a cerrar sin esfuerzo.'
  }];
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-16 text-center uppercase" data-id="element-53">
          ¿Cómo <span className="text-brand-orange" data-id="element-54">Funciona?</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-55">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gray-800 z-0" data-id="element-56"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-57">
              <div className="w-24 h-24 rounded-full bg-dark-bg border-4 border-brand-orange flex items-center justify-center font-oswald text-4xl font-bold text-brand-orange mb-6 shadow-[0_0_15px_rgba(255,107,53,0.3)]" data-id="element-58">
                {step.num}
              </div>
              <h3 className="font-oswald text-2xl font-bold mb-4 uppercase" data-id="element-59">
                {step.title}
              </h3>
              <p className="font-inter text-gray-400 text-lg" data-id="element-60">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}